import { useEffect } from "react";

let bodyScrollLockCount = 0;

export function useLockBodyScroll(isLocked) {
  useEffect(() => {
    const root = document.documentElement;

    if (isLocked) {
      bodyScrollLockCount += 1;
      root.style.overflow = "hidden";
    }

    return () => {
      if (!isLocked) {
        return;
      }

      bodyScrollLockCount = Math.max(0, bodyScrollLockCount - 1);

      if (bodyScrollLockCount === 0) {
        root.style.overflow = "auto";
      }
    };
  }, [isLocked]);
}
